export * from './record-data-table.component';
export * from './record-data-table.service';


// WEBPACK FOOTER //
// ./src/app/core/record-data-table/record-data-table.ts